import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissAfter: { type: Number, default: 5000 }
  }

  connect() {
    // Start visible
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-2")
      this.element.classList.add("opacity-100", "translate-y-0")
    })

    if (this.autoDismissValue) {
      this.dismissTimeout = setTimeout(() => {
        this.dismiss()
      }, this.dismissAfterValue)
    }
  }

  disconnect() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  dismiss() {
    this.element.classList.remove("opacity-100", "translate-y-0")
    this.element.classList.add("opacity-0", "translate-y-2")

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
